import { defaultToSnakeCase } from 'core/utils';

export const formatElementApiKey = (key: string) => {
  const API_KEYS = ['updateElements', 'addToElements', 'moveToElements', 'removeFromElements'];
  const API_KEYS_MAP = {
    updateElements: '__update__elements',
    addToElements: '__add_to__elements',
    moveToElements: '__move_to__elements',
    removeFromElements: '__remove_from__elements',
  };

  if (API_KEYS.includes(key)) {
    return API_KEYS_MAP[key];
  }

  return defaultToSnakeCase(key);
};
